/**
 * Browser detection utilities
 */
/**
 * Detects if the current browser is Safari (iOS or macOS)
 * @returns true if Safari, false otherwise
 */
export function isSafari() {
    // Check if we're in a browser environment
    if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
        return false;
    }
    const ua = navigator.userAgent;
    // Detect Safari on both iOS and macOS
    // Exclude Chromium-based browsers which also contain "Safari" in their UA:
    // - Chrome/Chromium (contains "Chrome" or "CriOS" for iOS)
    // - Edge (contains "Edg")
    // - Opera (contains "OPR")
    // - Android browsers (contains "Android")
    return /safari/i.test(ua) && !/chrome|crios|edg|opr|android/i.test(ua);
}
//# sourceMappingURL=browser-utils.js.map